import React, { useEffect } from 'react';
import m from './images/mobile.svg';

function AppMobile() {
    return (
        <div className='w-screen h-screen bg-[#1c2333] fixed overflow-hidden flex flex-col justify-center items-center'>
            <img src={m} className='max-w-[50%] max-h-[50%] animate-spin-bounce'></img>
            <h1 className='font-poppins text-white xl:text-2xl md:text-xl text-wrap sm:text-sm text-center py-10'>Responsive & Mobile mode are being developed!</h1>
            <h1 className='font-poppins text-white xl:text-2xl md:text-xl text-wrap sm:text-sm text-center py-10'>Please open in dekstop with minimum screen width 1500px and <strong>Refresh</strong> </h1>
        </div>
    );
}

export default AppMobile;
